export const requestFlat = {
  NEW_REQUEST: 'NEW_REQUEST',
  WORK_REQUEST: 'WORK_REQUEST',
  COMPLETED_REQUEST: 'COMPLETED_REQUEST',
  CLOSE_REQUEST: 'CLOSE_REQUEST',
};

export const requestFlatPeriod = {
  rightTime: 1, // Заявки с подходящим сроком выполнения
  expired: 2, // Просроченные заявки
  excess: 3, // Превышения проверочной даты
  finishingTouches: 4, // Чистовая отделка
};
